var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
class FcaLeadUtils {
}
_a = FcaLeadUtils;
FcaLeadUtils.storageKey = "fca-email-hash";
FcaLeadUtils.hashAndStoreEmail = (email) => __awaiter(void 0, void 0, void 0, function* () {
    if (!sessionStorage.getItem(FcaLeadUtils.storageKey)) {
        const hash = yield FcaLeadUtils.shaHash(email);
        if (hash) {
            sessionStorage.setItem(FcaLeadUtils.storageKey, hash);
        }
    }
});
FcaLeadUtils.retrieveEmailHash = (formSubmissionAttributes) => {
    const hash = sessionStorage.getItem(FcaLeadUtils.storageKey);
    if (hash) {
        formSubmissionAttributes.hashedEmail = hash;
        sessionStorage.removeItem(FcaLeadUtils.storageKey);
    }
};
FcaLeadUtils.shaHash = (message) => __awaiter(void 0, void 0, void 0, function* () {
    const msgUint8 = new TextEncoder().encode(message);
    const hashBuffer = yield crypto.subtle.digest("SHA-256", msgUint8);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
});
export { FcaLeadUtils };
